export const servicerProfileFormHeaderOptions = [
  { label: 'History', value: 'history', callback: 'onViewHistory' }
];
